import httpClient from '../../httpClient'
import { IInterview, IAvaInterview } from '../models'

export interface IUserInterviewsResponse {
  regular_interviews: IInterview[]
  ava_interviews: IAvaInterview[]
}

export const getUserInterviews = (): Promise<IUserInterviewsResponse> => {
  return httpClient.get('/my-interviews').then((response) => response.data)
}
